import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles((theme) => ({
  wrapper: {
    '& .mantine-TextInput-label, .mantine-InputWrapper-label': {
      color: theme.colors.brandGray[0],
      fontSize: '12px',
      fontWeight: 400
    },

    '& .mantine-Input-input': {
      borderRadius: '8px',
      border: '1px solid #D0D5DD'
    }
  }
}));
